import { createReducer, on } from "@ngrx/store"
import * as staffActions from './staffs.actions';

export interface StaffState {
    createStaffLoading: boolean;
    updateStaffLoading: boolean;

    allStaffs: [] | null;
    staffsError: boolean;
    staffsLoading: boolean;

    singleStaff: [] | null;
    singleStaffError: boolean;
    singleStaffLoading: boolean;
}

export const initialState: StaffState = {
    createStaffLoading: false,
    updateStaffLoading: false,

    allStaffs: null,
    staffsError: null,
    staffsLoading: null,

    singleStaff: null,
    singleStaffError: null,
    singleStaffLoading: null,
}

export const StaffsReducer = createReducer(
    initialState,

    on(staffActions.createStaff, (state) => ({
        ...state, createStaffLoading: true
    })),

    on(staffActions.createStaffSuccess, (state) => ({
        ...state, createStaffLoading: false,
    })),

    on(staffActions.createStaffFailed , (state) => ({
        ...state, createStaffLoading: false
    })),

    on(staffActions.updateStaff, (state) => ({
        ...state, updateStaffLoading: true
    })),

    on(staffActions.updateStaffSuccess, (state) => ({
        ...state, updateStaffLoading: false,
    })),

    on(staffActions.updateStaffFailed , (state) => ({
        ...state, updateStaffLoading: false
    })),

    on(staffActions.fetchStaffs, (state) => ({
        ...state, allStaffs: null, staffsError: null, staffsLoading: true
    })),

    on(staffActions.fetchStaffsSuccess, (state, {staffs}) => ({
        ...state, allStaffs: staffs, staffsError: false, staffsLoading: false
    })),

    on(staffActions.fetchStaffsFailed, (state) => ({
        ...state, allStaffs: null, staffsError: true, staffsLoading: false
    })),

    on(staffActions.fetchStaff, (state) => ({
        ...state, singleStaff: null, singleStaffError: null, singleStaffLoading: true
    })),

    on(staffActions.fetchStaffSuccess, (state, {staff}) => ({
        ...state, singleStaff: staff, singleStaffError: false, singleStaffLoading: false
    })),

    on(staffActions.fetchStaffFailed, (state) => ({
        ...state, singleStaff: null, singleStaffError: true, singleStaffLoading: false
    })),


)